import React, { useEffect, useState} from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';
import GlobalStyle from 'configs/GlobalStyle';
import { useSelector, useDispatch} from 'react-redux'
import axios from 'axios';
import institucionService from 'services/institucionService';
import './assets/css/menu.css';

import Exito from 'views/public-views/conexion/exito';

import {
	DptosAcademicos,
  CiclosEscolares,
  InfoGeneral,
  PlanesEstudio,
  ConjuntoPeriodos,
  Labels,
  EstructuraCustomNames,
  SetParametros
} from "./redux/actions/Sistema";

import {
  toggleCollapsedNav,
  onNavStyleChange,
  onLocaleChange,
  onNavTypeChange,
  onTopNavColorChange,
  onHeaderNavColorChange,
  // TOGGLE_MOBILE_NAV,
  onSwitchTheme,
  onDirectionChange,
  onBtnColorPrimaryChange,
  onSideNavBackgroundMenu,
  onSideNavItemActiveColor,
  onSideNavItemHoverColor,
  onSideNavItemColor,
  onUpdateMenuColors
} from "./redux/actions/Theme";



const themes = {

  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};


function  Login ({data}){
  const token = useSelector((state) => state.auth.token)
  const dispatch = useDispatch();
  const institucionTheme = JSON.parse(localStorage.getItem('dataEscuela')) ?
  JSON.parse(localStorage.getItem('dataEscuela')).theme : data.theme
  let menuStyles = {}
  if(institucionTheme){
    menuStyles = {
      bgColorMenu : institucionTheme.bgColorMenu,
      menuColorItem: institucionTheme.menuColorItem,
      menuColorItemHover:institucionTheme.menuColorItemHover,
      menuColorItemActive:institucionTheme.menuColorItemActive
    }
  }
  else{
    menuStyles = {
      bgColorMenu : 'black',
      menuColorItem:  'white',
      menuColorItemHover: 'red',
      menuColorItemActive: 'blue'
    }
  }

  const getData = async()=>{
    if(token){
      let institucion = await institucionService.Info();
      if(institucion.data){
        // dispatch(DptosAcademicos(institucion.data.DptosAcademicos))
        // dispatch(PlanesEstudio(institucion.data.planesEstudio))
        dispatch(Labels(institucion.data.labels))
        dispatch(EstructuraCustomNames(institucion.data.estructuraCustomNames))
        dispatch(InfoGeneral(institucion.data.info))

        let objeto = institucion.data.parametros
        for (const propiedad in objeto) {
          if (objeto.hasOwnProperty(propiedad)) { // Verificamos si la propiedad es propia del objeto
            let valor = objeto[propiedad];
            objeto[propiedad] = valor == '1' || valor == "true" ? true : false
          }
        }
        dispatch(SetParametros(objeto))
      }
      if(institucionTheme && Object.keys(institucionTheme).length !== 0){
        dispatch(onHeaderNavColorChange(institucionTheme.headerNavColor))
        dispatch(toggleCollapsedNav(parseInt(institucionTheme.navCollapsed)))
        dispatch(onNavStyleChange(institucionTheme.SIDE_NAV_DARK))
        dispatch(onLocaleChange(institucionTheme.locale))
        dispatch(onNavTypeChange(institucionTheme.navType))
        // dispatch(onTopNavColorChange(institucionTheme.topNavColor))
        dispatch(onSwitchTheme(institucionTheme.currentTheme))
        dispatch(onDirectionChange(institucionTheme.direction))
        dispatch(onDirectionChange(institucionTheme.direction))
        dispatch(onBtnColorPrimaryChange(institucionTheme.btnColorPrimary))
        //MENU
        let arr = {
          bgColorMenu: institucionTheme.bgColorMenu,
          menuColorItem:institucionTheme.menuColorItem,
          menuColorItemActive:institucionTheme.menuColorItemActive,
          menuColorItemHover:institucionTheme.menuColorItemHover
        }
        dispatch(onUpdateMenuColors(arr))
      }
    }
  }
  useEffect(()=>{

    getData()
  },[token])
  return(
    
    <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
      <GlobalStyle 
      menuStyles={menuStyles}
      btnColorPrimary={institucionTheme && institucionTheme.btnColorPrimary}
       />
      <Router>
        <Switch>
          <Route path="/" component={Views}/>

        </Switch>
      </Router>
    </ThemeSwitcherProvider>
  
  )
}

function App() {


  const [subdomain, setSubDomain] = useState(null);
  const [existe, setExistencia] = useState(null);
  const [mensaje, setMensaje] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() =>{
    localStorage.removeItem('dataEscuela')

    const host = window.location.host;
    let urlParts = /^(?:\w+:\/\/)?([^]+)([^]*)\??(.*)$/.exec(host);
    let hostname = urlParts[1]; // www.example.com
    // let path = urlParts[2];
    if(hostname) {
      let sub = hostname;
      setSubDomain(sub);
    }

  },[]);

  useEffect(()=>{

  if(subdomain !== null){
    axios.post('https://api.facturasiempre.com//api/institucion/getid', {
      domain: subdomain,
      })
      .then(function (response) {
        setData(response.data)
        if(response.data.customDomain !== undefined && response.data.customDomain !== subdomain &&  response.data.customDomain !== null ){
          // window.location.replace('https://'+response.data.customDomain);
          setExistencia(true)
          localStorage.setItem('dataEscuela', JSON.stringify(response.data));

        }
        else if(response.data.id){
          setExistencia(true)
          localStorage.setItem('dataEscuela', JSON.stringify(response.data));
        }
        else{
          setMensaje({titulo:response.data.message,mensaje:response.data.messageContent})
        }
    })
  }
  },[subdomain]);



  return (
    <div className="App">
      {
        existe ? <Provider store={store}> <Login data={data}  /></Provider> :  mensaje ? <Exito mensaje={mensaje} /> : ''
      }
    </div>
  );
}

export default App;
